import { defaultP,paramsData } from './../utils/resize';
import { service } from './store_service'

const { cache } = useCache('local')
// localStorage.setItem('TU_TOKEN', defaultP.token)
const request = (option: any) => {
  let { url, method, params, data, headers, responseType } = option
  const runConfig = useRuntimeConfig()
  // if (localStorage.getItem('TU_TOKEN') && method === 'post') {
  //   option.data = { ...{}, ...defaultP, ...data }
  // } else if (localStorage.getItem('TU_TOKEN') && method === 'get') {
  //   option.params = { ...{}, ...defaultP, ...params }
  // }
  params = {clientId: cache.get('TU_CLIENTID') || '', gameInfo: paramsData.cloudId + ':' + paramsData.appId + ':' + paramsData.gameId,...params}
  return service({
    baseURL: runConfig.public.baseUrl,
    url: url,
    method,
    params: cache.get('TU_TOKEN') && method === 'get' ? { ...{}, ...defaultP, ...params } : params,
    data: method === 'post' ? { ...{}, ...defaultP, ...data } : data,
    responseType: responseType,
    headers: headers || {}
  })
}

export default {
  get: <T = any>(option: any) => {
    return request({ method: 'get', ...option }) as unknown as T
  },
  post: <T = any>(option: any) => {
    return request({ method: 'post', ...option }) as unknown as T
  },
  delete: <T = any>(option: any) => {
    return request({ method: 'delete', ...option }) as unknown as T
  },
  put: <T = any>(option: any) => {
    return request({ method: 'put', ...option }) as unknown as T
  }
}
